import React, { useMemo, useState } from 'react';
import JoditEditor from 'jodit-react';
import Attention from '../../ReusableComponents/Attention';
import PortalFieldHelp from './PortalFieldHelp';

export const richTextIsEmpty = (html) =>
  !String(html || '')
    .replace(/<[^>]*>/g, '')
    .replace(/&nbsp;|&#160;/g, ' ')
    .trim();
export default function PortalRichTextField({
  name,
  label,
  value = '',
  disabled,
  required,
  help,
  placeholder = '',
  height = 240,
}) {
  const [html, setHtml] = useState(value);
  const config = useMemo(
    () => ({
      language: 'pt_br',
      height,
      readonly: !!disabled,
      toolbarAdaptive: false,
      buttons: [
        'bold',
        'italic',
        'underline',
        '|',
        'ul',
        'ol',
        '|',
        'paragraph',
        'align',
        '|',
        'link',
        'table',
        '|',
        'undo',
        'redo',
        '|',
        'eraser',
        'source',
      ],
      showCharsCounter: false,
      showWordsCounter: false,
      showXPathInStatusbar: false,
      placeholder,
    }),
    [disabled, height, placeholder]
  );
  return (
    <div className="portal-rich-field">
      <div className="form-label portal-field-label" id={`${name}-label`}>
        {label}
        {required ? <Attention /> : <small className="text-muted"> (opcional)</small>}
        {help && <PortalFieldHelp label={label}>{help}</PortalFieldHelp>}
      </div>
      <input type="hidden" name={name} value={html} readOnly />
      <div role="group" aria-labelledby={`${name}-label`}>
        <JoditEditor value={html} config={config} onChange={setHtml} onBlur={setHtml} />
      </div>
    </div>
  );
}
